import React from "react";
import { useNavigate } from "react-router-dom";
import { Smile, RefreshCw } from "lucide-react";
import { useFlow } from "@/flowStore";

export default function Success() {
  const navigate = useNavigate();
  const { reset } = useFlow();

  const restart = () => {
    reset();
    navigate("/", { replace: true });
  };

  return (
    <div className="screen" data-testid="success-screen">
      <div className="gradient-bg" />
      <div className="screen-scroll">
        <div className="success-content fade-up">
          <div className="smiley">
            <Smile size={110} strokeWidth={1.5} />
          </div>

          <div className="title-pill">
            <span>SANTÉ !</span>
          </div>

          <div className="success-card">
            <div className="success-heading">Ta photo est dans la cave 🍷</div>
            <p className="success-text">
              Merci d&apos;avoir relevé le défi. Le tirage au sort aura lieu après le festival — on
              revient vers toi par e-mail si tu remportes le coffret d&apos;été !
            </p>
          </div>

          <button className="cta-wrap" style={{ marginTop: 32 }} data-testid="restart-button" onClick={restart}>
            <div className="cta">
              <RefreshCw size={26} color="#E97160" />
              <span className="cta-text">au suivant</span>
            </div>
          </button>
        </div>
      </div>
    </div>
  );
}
